import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import style from './style.module.less';

export const RemoveAllFiltersDropdownMenuItem = ({ hasExistingFilters, onRemoveAllFiltersButtonClick }) => {
  return (
    <DropdownMenuItem className={style['checklist-remove-row']} disabled={!hasExistingFilters} onClick={onRemoveAllFiltersButtonClick}>
      <FontAwesomeIcon
        className={classnames(style.icon, {
          [style.disabled]: !hasExistingFilters,
        })}
        icon={faBan}
      />
      <div className={style['remove-text']}>
        <FormattedMessage
          className={style['remove-text']}
          defaultMessage='Remove Filters'
          description='filterOptions.removeFilter'
          id='gg7HRL'
        />
      </div>
    </DropdownMenuItem>
  );
};

RemoveAllFiltersDropdownMenuItem.propTypes = {
  hasExistingFilters: PropTypes.bool.isRequired,
  onRemoveAllFiltersButtonClick: PropTypes.func.isRequired,
};
